export default "__VITE_ASSET__CUpZTgVJ__"